import * as React from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { RootState, SharedActions } from '../../../Store'
import { ParametroProjeto } from '../../../Domain/Shared'

export const useProjetos = (perfil: string, professorId?: string) => {
  const dispatch = useDispatch()
  const projetos = useSelector((state: RootState) => state.Shared.projetos)
  const projetosOficinasDebate = useSelector((state: RootState) => state.Shared.projetosOficinasDebate)
  const projetosEncontrosJuridicos = useSelector((state: RootState) => state.Shared.projetosEncontrosJuridicos)
  const parametroProjetoList = useSelector((state: RootState) => state.Shared.parametroProjetoList)
  const parametroProjetoListApiState = useSelector((state: RootState) => state.Shared.apiStates.parametroProjetoListAction)
  const parametroProjeto = useSelector((state: RootState) => state.Shared.parametroProjeto)
  const parametroProjetoApiState = useSelector((state: RootState) => state.Shared.apiStates.parametroProjetoAction)
  const cadastrarParametroProjetoApiState = useSelector((state: RootState) => state.Shared.apiStates.cadastrarParametroProjetoAction)
  const cadastrarOrientacaoApiState = useSelector((state: RootState) => state.Shared.apiStates.cadastrarOrientacaoAction)
  const getProjetoListApiState = useSelector((state: RootState) => state.Shared.apiStates.updateProjetosAction)
  const getProjetoOficinaDebateListApiState = useSelector((state: RootState) => state.Shared.apiStates.updateProjetosOficinaDebateAction)
  const getProjetoEncontrosJuridicosListApiState = useSelector((state: RootState) => state.Shared.apiStates.updateProjetosEncontroJuridicoAction)

  React.useEffect(() => {
    dispatch(SharedActions.parametroProjetoAction())
    dispatch(SharedActions.parametroProjetoListAction())
    dispatch(SharedActions.updateProjetosAction(perfil, professorId))
    if(perfil !== 'funcionario') dispatch(SharedActions.updateProjetosOficinaDebateAction(perfil))
    if(perfil !== 'funcionario') dispatch(SharedActions.updateProjetosEncontroJuridicoAction(perfil))
  }, [dispatch])

  const updateProjetoList = (perfil: string, professorId: string) => {
    dispatch(SharedActions.updateProjetosAction(perfil, professorId))
  }

  const updateParametroProjetoList = () => {
    dispatch(SharedActions.parametroProjetoListAction())
  }

  const updateProjetoOficinasDebateList = (perfil: string) => {
    dispatch(SharedActions.updateProjetosOficinaDebateAction(perfil))
  }

  const updateProjetoEncontrosJuridicosList = (perfil: string) => {
    dispatch(SharedActions.updateProjetosEncontroJuridicoAction(perfil))
  }

  const cadastrarParametroProjeto = (parametroProjeto: ParametroProjeto, 
    dataDeInicioRP?: string | undefined, dataDeFimRP?: string | undefined,
    dataDeInicioRF?: string | undefined, dataDeFimRF?: string | undefined,
    dataDeInicioEJC?: string | undefined, dataDeFimEJC?: string | undefined,
    dataDeInicioOD?: string | undefined, dataDeFimOD?: string | undefined,
    id?: Number | undefined) => {
    dispatch(SharedActions.cadastrarParametroProjetoAction(
      parametroProjeto,
      dataDeInicioRP, dataDeFimRP,
      dataDeInicioRF, dataDeFimRF,
      dataDeInicioEJC, dataDeFimEJC,
      dataDeInicioOD, dataDeFimOD, id))
  }

const cadastrarOrientacao = (
    dataDeInicio?: string | undefined, dataDeFim?: string | undefined,
    resumo?: string | undefined, projetoId?: Number | undefined) => {
    dispatch(SharedActions.cadastrarOrientacaoAction(
      dataDeInicio, dataDeFim,
      resumo, projetoId))
  }

  return {
    projetosOficinasDebate,
    projetosEncontrosJuridicos,
    projetos,
    parametroProjetoList,
    parametroProjeto,
    parametroProjetoApiState,
    parametroProjetoListApiState,
    cadastrarParametroProjetoApiState,
    cadastrarOrientacaoApiState,
    cadastrarOrientacao,
    getProjetoListApiState,
    getProjetoOficinaDebateListApiState,
    getProjetoEncontrosJuridicosListApiState,
    cadastrarParametroProjeto,
    updateParametroProjetoList,
    updateProjetoList,
    updateProjetoOficinasDebateList,
    updateProjetoEncontrosJuridicosList
  }
}
